import api from '../callApi';
import { getGoogleAnalyticsClientIds } from './googleAnalytics';
import { NativePaymentsTypes, SupportContactRepCountryCodes } from '../../utils/enums';
import { ActionTypes } from '../../utils/enums';

const trackingUrl = 'Widget/RecordActivity';

function getActionData(action, actionCancelTime) {
    return {
        id: action.id,
        actionId: action.actionId,
        type: action.type,
        partnerId: action.partner ? action.partner.id : null,
        order: action.order,
        issueId: action.issue ? action.issue.id : null,
        isVisual: action.isVisual,
        subIssueId: action.subIssue ? action.subIssue.id : null,
        widgetCardId: action.widgetCardId,
        cancelledTime: actionCancelTime,
        skipEndCard: action.skipEndCard,
    };
}

function isFallbackAction(state){
    const isRepStance = state.widget.activeAction.type === ActionTypes.CheckRepPosition;
    const useLocalRepresentative = !!state.widget.activeAction.representativeSearch || isRepStance;
    const localRepData = state.localRep.localRepData || {};
    const endUserLocation = state.widget.endUserLocation || {};

    return useLocalRepresentative &&
            !localRepData.address &&
            !SupportContactRepCountryCodes.includes(endUserLocation.countryCode);
}

function getRequestFromState(state, type, eventData, actionCancelTime) {
    return {
        clientIdCustom: state.widget.clientIdCustom,
        type,
        articleUrlTracking: state.widget.articleUrlTracking,
        widgetId: state.widget.widgetId,
        widgetEmbedType: state.widget.embedType,
        widgetType: state.widget.widgetType,
        articleId: state.widget.articleId,
        publisherId: state.widget.publisherId,
        publishedDate: state.widget.publishedDate,
        ...getGoogleAnalyticsClientIds(),
        location: {
            latitude: (state.widget.endUserLocation || {}).latitude,
            longitude: (state.widget.endUserLocation || {}).longitude
        },
        eventData,
        actions: [getActionData(state.widget.activeAction, actionCancelTime)],
        sponsored: state.widget.isSponsored,
        isFallbackAction: isFallbackAction(state)
    };
}

function trackVideoProgressed(state, progressFloat) {
    const request = getRequestFromState(state, 'VideoProgressed', progressFloat);
    return api.post(trackingUrl, request);
}

function trackActionUpdated(state) {
    const request = getRequestFromState(state, 'ActionUpdated');
    return api.post(trackingUrl, request);
}

const initiatedActions = [];
function trackActionInit(state) {
    const id = state.widget.activeAction.identifier;
    if (initiatedActions.includes(id)) return;
    initiatedActions.push(id);

    const request = getRequestFromState(state, 'ActionInitiated');
    api.post(trackingUrl, request).catch(e => {});
}

function trackActionCompleted(state) { //only for global fallback at the moment, other actions are tracked on the back end via completed api endpoint call
    const request = getRequestFromState(state, 'ActionCompleted');
    api.post(trackingUrl, request).catch(e => {});
}

function trackSharedAction(state, sharedWith) {
    const request = getRequestFromState(state, 'ActionShared', sharedWith);

    if (
        state.router.location.pathname !== '/multiActionsCard' &&
        state.router.location.pathname !== '/targetedMultiAction' &&
        state.router.location.pathname !== '/singleAction'
    ) {
        api.post(trackingUrl, request).catch(e => {});
    } else {
        api.post(trackingUrl, {
            ...request,
            actions: state.widget.actions
                .filter(a => a.order === state.widget.activeAction.order)
                .map(a => getActionData(a))
        }).catch(e => {});
    }
}

function trackPaymentProviderSelected(state, paymentType) {
    let providerName;
    switch (paymentType) {
        case NativePaymentsTypes.credtCard:
            providerName = 'CreditCard';
            break;
        case NativePaymentsTypes.venmo:
            providerName = 'Venmo';
            break;
        case NativePaymentsTypes.applePay:
            providerName = 'ApplePay';
            break;
        case NativePaymentsTypes.googlePay:
            providerName = 'GooglePay';
            break;
        default:
            throw new Error(`Unrecognized payment type: ${paymentType}`);
    }
    const request = getRequestFromState(state, 'PaymentProviderSelected', providerName);
    api.post(trackingUrl, request).catch(e => {});
}

function trackCancelAction(state, actionCancelTime) {
    const request = getRequestFromState(state, 'ActionCancelled', null, actionCancelTime);
    api.post(trackingUrl, request).catch(e => {});
}

function trackWidgetVisible(state) {
    const request = getRequestFromState(state, 'WidgetVisible');
    return api
        .post(trackingUrl, {
            ...request,
            actions: state.widget.actions.map(a => getActionData(a))
        })
        .catch(e => {});
}

function trackWidgetEngaged(state) {
    const request = getRequestFromState(state, 'Engaged');
    api.post(trackingUrl, request).catch(e => {});
}

function trackActionVisible(state) {
    const request = getRequestFromState(state, 'ActionVisible');
    api.post(trackingUrl, request).catch(e => {});
}

function trackNewsletterSubscription(state) {
    const request = getRequestFromState(state, 'NewsletterSubscription');
    api.post(trackingUrl, request).catch(e => {});
}

function trackActionChosen(state) {
    const request = getRequestFromState(state, 'ActionChosen');
    api.post(trackingUrl, request).catch(e => {});
}

export default {
    trackActionChosen,
    trackActionUpdated,
    trackActionVisible,
    trackCancelAction,
    trackActionCompleted,
    trackNewsletterSubscription,
    trackActionInit,
    trackPaymentProviderSelected,
    trackSharedAction,
    trackVideoProgressed,
    trackWidgetEngaged,
    trackWidgetVisible
};
